import React from 'react';
import { motion } from 'framer-motion';
interface CyberCardProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  glowColor?: 'purple' | 'cyan' | 'green';
}
export function CyberCard({
  children,
  className = '',
  delay = 0,
  glowColor = 'cyan'
}: CyberCardProps) {
  const glowStyles = {
    purple: 'hover:shadow-neon-purple border-cyber-purple/30 hover:border-cyber-purple',
    cyan: 'hover:shadow-neon-cyan border-cyber-cyan/30 hover:border-cyber-cyan',
    green: 'hover:shadow-neon-green border-cyber-green/30 hover:border-cyber-green'
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} className={`
        relative bg-cyber-dark border backdrop-blur-sm
        transition-all duration-300 group
        ${glowStyles[glowColor]}
        ${className}
      `} data-id="element-166">
      {/* Corner Accents */}
      <div className={`absolute top-0 left-0 w-2 h-2 border-t-2 border-l-2 transition-colors duration-300 ${glowColor === 'purple' ? 'border-cyber-purple' : glowColor === 'green' ? 'border-cyber-green' : 'border-cyber-cyan'}`} data-id="element-167" />
      <div className={`absolute top-0 right-0 w-2 h-2 border-t-2 border-r-2 transition-colors duration-300 ${glowColor === 'purple' ? 'border-cyber-purple' : glowColor === 'green' ? 'border-cyber-green' : 'border-cyber-cyan'}`} data-id="element-168" />
      <div className={`absolute bottom-0 left-0 w-2 h-2 border-b-2 border-l-2 transition-colors duration-300 ${glowColor === 'purple' ? 'border-cyber-purple' : glowColor === 'green' ? 'border-cyber-green' : 'border-cyber-cyan'}`} data-id="element-169" />
      <div className={`absolute bottom-0 right-0 w-2 h-2 border-b-2 border-r-2 transition-colors duration-300 ${glowColor === 'purple' ? 'border-cyber-purple' : glowColor === 'green' ? 'border-cyber-green' : 'border-cyber-cyan'}`} data-id="element-170" />

      {children}
    </motion.div>;
}